"use client";
import { useLayoutEffect } from "react";
import {
  commitNavigationActivity,
  completeNavigationActivity,
} from "./navigation-activity";

export function NavigationActivityObserver({
  pathname,
  search,
}: {
  readonly pathname: string;
  readonly search: string;
}) {
  useLayoutEffect(() => {
    commitNavigationActivity({ pathname, search });
  }, [pathname, search]);
  useLayoutEffect(() => {
    const onRestore = (event: PageTransitionEvent) => {
      if (event.persisted) completeNavigationActivity({});
    };
    window.addEventListener("pageshow", onRestore);
    return () => {
      window.removeEventListener("pageshow", onRestore);
      completeNavigationActivity({});
    };
  }, []);
  return null;
}
